import { render } from "./QrPromptpay.vue?vue&type=template&id=1337e246"
import script from "./QrPromptpay.vue?vue&type=script&lang=js"
export * from "./QrPromptpay.vue?vue&type=script&lang=js"
script.render = render

export default script